import script from "./CartBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./CartBoard.vue?vue&type=script&setup=true&lang=js"

import "./CartBoard.vue?vue&type=style&index=0&id=2c673a4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c673a4b"]])

export default __exports__